// extracted by mini-css-extract-plugin
export default {"title":"dOwWh1OHWmZsWu0SLIxy","root":"fdxqJ4v4AKskAVI9qncx","preview":"Vj1SiBBKXCb5bPPyEBLc"};